export const SET_PAYMENT_METHOD_LIST = 'SET_PAYMENT_METHOD_LIST';
